import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (_theme, _ref) {
  var orientation = _ref.orientation,
      placement = _ref.placement;
  return {
    root: {
      display: orientation === "vertical" ? "flex" : void 0,
      flexDirection: placement === "right" ? "row-reverse" : "row"
    }
  };
});
export default useStyles;